/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenGenericIcon16Solid = forwardRef('TechScreenGenericIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M15 4.7A2.7 2.7 0 0 0 12.3 2H3.7A2.7 2.7 0 0 0 1 4.7v4.6A2.7 2.7 0 0 0 3.7 12h8.6A2.7 2.7 0 0 0 15 9.3V4.7Z" }),
        React.createElement("path", { d: "M4 13a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H4Z" })));
});
